import React, { lazy } from "react";
import {
  HashRouter,
  Redirect,
  Route,
  Switch,
  useLocation,
} from "react-router-dom";
import "./index.css";
import ForgotPassword from "./views/LoginPage/ForgotPassword.js";
import ReactGA from "react-ga";
import AdminDashboard from "./views/AdminDashboard/AdminDashboard.js";
import UserDashboard from "./views/UserDashboard/UserDashboard.js";

import EditRole from "./views/Rules/AddRuleStepper";
import Rules from "./views/Rules/Rules.js";
// import NewRules from "./views/Rules/NewRules";
import NewRule from "./views/Rules/NewRules";
import Dashboard from "./views/Dashboard.js";
import AddRule from "./views/Rules/AddRuleStepper.js";
import SignUp from "./views/LoginPage/SignUp.js";
import UserProfile from "./views/Users/UserProfile";
import Fields from "./views/Fields/Fields.js";
import AddField from "./views/Fields/AddField.js";
import EditField from "./views/Fields/EditField";
import CreatenewRule from "./views/Rules/CreatenewRule";
import Editrulecreated from "./views/Rules/Editrulepage";
import Sensor from "./views/Fields/Sensor";
import AddSensor from "./views/Fields/AddSensor";
import UpdateSensor from "./views/Fields/UpdateSensor";
import Device from "./views/Device/Device";
import AddDevice from "./views/Device/AddDevice";
import EditDevice from "./views/Device/EditDevice";
import Header from "../src/components/Header";
import Footer from "../src/components/Footer";
import MainSidebar from "../src/components/mainSidebar";
import CssBaseline from "@material-ui/core/CssBaseline";
import Notification from "./views/Notification";
import NotifyMe from "./views/NotifyMe";
import Assets from "./views/AssetManagement/Assets.js";
import AddItem from "./views/AssetManagement/AddItem.js";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "react-datepicker/dist/react-datepicker.css";
import EditItem from "./views/AssetManagement/EditItem";
import EditManufacturer from "./views/Manufacturer/EditManufacturer";
import AddManufacturer from "./views/Manufacturer/AddManufacturer";
import Manufacturer from "./views/Manufacturer/Manufacturer";
import Rulelistview from "./views/Rules/RulesListView";
import RelatedRulelist from "./views/Rules/RelatedRulelist";
import Tablepaginate from "./views/Rules/Tablepaginate";

import RuleLogpage from "./views/Rules/RuleLogPage";
import AuditLogpage from "./views/Rules/AuditLogPage.js";
import AllRuleLogpage from "./views/Rules/AllRuleLogs.js";
import ViewLogDetails from "./views/Rules/ViewAllLog.js";
import TimeZone from "./views/Rules/TimeZone.js";
import ViewAllNotifications from "./views/UserDashboard/ViewAllNotification.js";
import {
  Settings,
  Lock,
  DescriptionOutlined,
  DashboardOutlined,
  GavelOutlined,
  PeopleAltOutlined,
  LeakAdd,
  DeviceHub,
  Tune,
  NotificationImportant,
  ScatterPlot,
  DynamicFeed,
} from "@material-ui/icons";
import { useHistory } from "react-router-dom";
import { useAuthenticated } from "./views/CommanLoginauth.js";

const DashboardNew = lazy(() =>
  import("./views/UserDashboard/Dashboard/Dashboard.js")
);
const Parking = lazy(() => import("./views/Screens/Parking.js"));
const Reports = lazy(() => import("./views/Screens/Reports.js"));
const Users = lazy(() => import("./views/Users/UsersInfo.js"));
const AddUser = lazy(() => import("./views/Users/AddUser.js"));
const EditUser = lazy(() => import("./views/Users/EditUser.js"));
const AddFeature = lazy(() => import("./views/AccessManagement/AddFeature.js"));
const AccountDashboard = lazy(() => import("./views/Users/Myaccount"));
const AddRole = lazy(() => import("./views/AccessManagement/AddRole.js"));
const AddRolePermission = lazy(() =>
  import("./views/AccessManagement/AddRolePermission.js")
);
const AccessManagement = lazy(() =>
  import("./views/AccessManagement/AccessManagement.js")
);

const sideBarOptions = [
  {
    name: "Dashboard",
    url: "/overview",
    icon: <DashboardOutlined />,
    permission: "UserDashboard",
    permissionType: "read",
  },
  {
    name: "Users",
    url: "/users",
    icon: <PeopleAltOutlined />,
    permission: "UserManagement",
    permissionType: "read",
  },
  {
    name: "Access Management",
    url: "/accessmanagement",
    icon: <Lock />,
    permission: "AccessManagement",
    permissionType: "read",
  },
  {
    name: "Reports",
    url: "/reports",
    icon: <DescriptionOutlined />,
    permission: "Reports",
    permissionType: "read",
  },
];

function ScrollToTopOnPageChange() {
  const { pathname } = useLocation();
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function PrivateRoute({ component: Component, ...rest }) {
  const isAuthenticated = useAuthenticated();
  const history = useHistory();
  // console.log("isauth =======> " + isAuthenticated);
  return (
    <Route
      {...rest}
      render={(props) =>
        isAuthenticated ? (
          <div style={{ marginLeft: 40, marginTop: 65 }}>
            <Component {...props} {...rest} />
          </div>
        ) : (
          (() => {
            history.push("/login");
            return null;
          })()
        )
      }
    />
  );
}

function Main({ parkArray }) {
  return (
    <>
      <CssBaseline />
      <ToastContainer />
      <MainSidebar sideBarOptions={sideBarOptions} />
      <ScrollToTopOnPageChange />
      <Switch>
        <PrivateRoute
          path="/overview"
          component={DashboardNew}
          parkArray={parkArray}
          isAdmin={true}
        />
        <PrivateRoute path="/admin/parking" component={Parking} />
        <PrivateRoute
          path="/reports"
          parkArray={parkArray}
          component={Reports}
        />
        <PrivateRoute path="/users" component={Users} />
        <PrivateRoute path="/adduser" component={AddUser} />
        <PrivateRoute path="/edituser" component={EditUser} />
        <PrivateRoute path="/accessmanagement" component={AccessManagement} />
        <PrivateRoute path="/addfeature" component={AddFeature} />
        <PrivateRoute path="/myaccount" component={AccountDashboard} />
        <PrivateRoute path="/updatepermissions" component={AddRolePermission} />
        <PrivateRoute path="/addrole" component={AddRole} />

        {/* <Route path="/Settings" component={AdminDashboard} /> */}

        {/* <Route
          exact
          path="/admin/Parking"
          render={() => (
            <div
              style={{ marginTop: "5rem", marginLeft: "5rem", padding: "1rem" }}
            >
              <Parking />
            </div>
          )}
        /> */}
        {/* <Route path="/accessmanagement" component={AccessManagment} /> */}
        {/* <Route path="/accessmanagement" component={AccessManagment} /> */}
        {/* <Route path="/Dashboard" component={Dashboard} /> */}
        {/* <Route path="/overview" component={UserDashboard} /> */}
        {/* <Route path="/tenniscourts" component={UserDashboard} /> */}
        {/* <Route path="/MAFC" component={UserDashboard} /> */}
        {/* <Route path="/churchstreettenniscourts" component={UserDashboard} /> */}
        {/* <Route path="/ChurchStreetPark" component={UserDashboard} /> */}
        {/* <Route path="/cfdppark" component={UserDashboard} /> */}
        {/* <Route path="/CederForkDistrictPark" component={UserDashboard} /> */}
        {/* <Route path="/mcppark" component={UserDashboard} /> */}
        {/* <Route path="/MorrisvilleCommunityPark" component={UserDashboard} /> */}
        {/* <Route path="/shiloh" component={UserDashboard} />
        <Route path="/ccnp" component={UserDashboard} />
        <Route path="/AdminDashboard" component={UserDashboard} />
        <Route path="/AccessManagment" component={AccessManagment} />
        <Route path="/EditRole" component={EditRole} />
        <Route path="/AddRolePermission" component={AddRolePermission} />
        <Route path="/SignUp" component={SignUp} />
        <Route path="/ForgotPassword" component={ForgotPassword} />
        <Route path="/UserProfile" component={UserProfile} />
        <Route path="/MyAccount" component={AccountDashboard} />
        <Route path="/AddRule" component={AddRule} />
        <Route path="/EditUser" component={EditUser} />
        <Route path="/Users" component={Users} />
        <Route path="/field" component={Fields} />
        <Route path="/editfield" component={EditField} />
        <Route path="/AddUser" component={AddUser} />
        <Route path="/AddSensor" component={AddSensor} />
        <Route path="/EditSensor" component={UpdateSensor} />
        <Route path="/Device" component={Device} /> */}
        {/* <Route path="/humsub" component={DemoEvent} /> */}
        {/* <Route path="/EditDevice" component={EditDevice} />
        <Route path="/Sensor" component={Sensor} />
        <Route path="/notification" component={Notification} />
        <Route path="/notifyme" component={NotifyMe} />
        <Route path="/AssetManagement" component={Assets} />
        <Route path="/AddItem" component={AddItem} />
        <Route path="/EditItem" component={EditItem} /> */}
        {/* <Route path="/newrules" component={NewRules} /> */}
        {/* <Route path="/Manufacturer" component={Manufacturer} />
        <Route path="/EditManufacturer" component={EditManufacturer} /> */}
        {/* Private Route */}
        {/* <PrivateRoute path="/NewRule" component={NewRule} />
        <PrivateRoute path="/Rules" component={Rules} />
        <PrivateRoute path="/createnewRule" component={CreatenewRule} />
        <PrivateRoute path="/rulelistview" component={Rulelistview} />
        <PrivateRoute path="/editrulecreate" component={Editrulecreated} />
        <PrivateRoute path="/relatedRulelist" component={RelatedRulelist} />
        <PrivateRoute path="/tablepaginate" component={Tablepaginate} />
        <PrivateRoute path="/RuleLogpage" component={RuleLogpage} />
        <PrivateRoute path="/TimeZone" component={TimeZone} />
        <PrivateRoute path="/AuditLogpage" component={AuditLogpage} />
        <PrivateRoute path="/allrulelogspage" component={AllRuleLogpage} />
        <PrivateRoute path="/ViewLogDetails" component={ViewLogDetails} />
        <PrivateRoute
          path="/allNotifications"
          component={ViewAllNotifications}
        /> */}
        {/* <PrivateRoute path="/AddFeature" component={AddFeature} />
        
        <PrivateRoute path="/AddField" component={AddField} />
        <PrivateRoute path="/AddDevice" component={AddDevice} /> */}
        {/* <PrivateRoute path="/AddManufacturer" component={AddManufacturer} /> */}

        {/* Private Route */}
        <Redirect path="*" to="/" />
      </Switch>
      {/* <Footer /> */}
      {/* <Footer /> */}
    </>
  );
}

export default Main;
